import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { paths } from '../../config/router.config';
import NotificationsView from './NotificationsView';

export default function NotificationsControlle(props){
    const {t} = useTranslation();
    const history = useHistory();

    const onDetail = (detail) => {
        console.log("detail===", detail);
        if(detail && detail.row){
            history.push(paths.notifications_detail, {detail: detail.row});
        }
    }

    return (
        <NotificationsView 
            onDetail={onDetail}
        />
    );
}